export default __webpack_public_path__ + "static/media/603397c124b897b3f485a9e337ca8dad.svg";